import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../../constants/ActionTypes";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import { setLoader } from "../../ui/actions";
import { apiRequest } from "../../api/actions";
import { createErrorNotification } from "../../notification/actions";
import { setContractsAction } from "./actions";
import { setNotFound } from "../../redirection/actions";
import { getSessionData } from "../../sessionData/actions";
import { getItemFromSessionStorage } from "../../../../utilites/localStorage";
import Validator from "../../../../validators/Validator";

const ContractMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);
  switch (action.type) {
  case ActionTypes.CONTRACT.MANHATTAN.FETCH_CONTRACTS:

    next(apiRequest(
      null,
      'GET',
      `${ApiUrls.FETCH_CONTRACTS}`,
      action.params,
      null,
      MiddlewareEntities.CONTRACT.MANHATTAN,
      {}),
    );
    next(setLoader(true, MiddlewareEntities.CONTRACT.MANHATTAN));
    break;
  case `${MiddlewareEntities.CONTRACT.MANHATTAN} ${ActionTypes.API_SUCCESS}` :
    next(getSessionData(action.payload.data.session));
    if (!store.getState().session.user.isLoggedIn) {
      return store.dispatch(setNotFound());
    }
    next(setContractsAction(action.payload.data.data.contracts));
    next(setLoader(false, MiddlewareEntities.CONTRACT.MANHATTAN));
    break;
  case `${MiddlewareEntities.CONTRACT.MANHATTAN} ${ActionTypes.API_ERROR}` :
    next(setLoader(false, MiddlewareEntities.CONTRACT.MANHATTAN));
    next(createErrorNotification(action.payload.data,  MiddlewareEntities.CONTRACT.MANHATTAN));
    break;

  case ActionTypes.CONTRACT.MANHATTAN.SET_CONTRACT_IN_SESSION_STORAGE:
    sessionStorage.setItem("contract", JSON.stringify(action.payload.data));
    break;
  case ActionTypes.CONTRACT.MANHATTAN.GET_CONTRACTS:
    const sessionStorageContract = getItemFromSessionStorage('contract', '{}');
    if (Validator.checkIfObjectHasPropKeys(sessionStorageContract)) {
      next(setContractsAction([sessionStorageContract]));
    }
    break;
  }
};


export default ContractMiddleware;


